import { FormInstance } from 'antd';
import { NamePath } from '@xbcb/ui-types';
import { HtsValues } from 'context/htsValues';
import { clearFields } from 'libs/clearFields';
import { formatHTSNumber } from 'libs/format';
import { tariffKey } from './namePaths';
import { TariffWithHtsNumber } from './getTariffsWithDefinedHts';

export type RemoveAdditionalTariffArgs = [
  tariffIndex: number,
  form: FormInstance,
  fullNamePath: NamePath,
  htsValues: HtsValues,
];
export type RemoveAdditionalTariff = (
  ...args: RemoveAdditionalTariffArgs
) => Promise<string | undefined>;

export const removeAdditionalTariff: RemoveAdditionalTariff = async (
  tariffIndex,
  form,
  fullNamePath,
  htsValues,
) => {
  const { getFieldValue, setFields } = form;
  const existingTariffs = getFieldValue([...fullNamePath, 'tariffs']);

  if (!existingTariffs) return undefined;

  // Filter out the tariff at tariffIndex and shift remaining tariffs up
  const updatedTariffs = existingTariffs
    .filter(
      (existingTariff: TariffWithHtsNumber, index: number) =>
        existingTariff && index !== tariffIndex,
    )
    .map((tariff: TariffWithHtsNumber, index: number) => ({
      ...tariff,
      htsNumber: formatHTSNumber(
        tariff.htsNumber ?? tariff.number ?? tariff.hts?.number,
      ),
    }));

  // Clear all existing tariff fields
  clearFields({
    form,
    fullNamePath: [...fullNamePath, 'tariffs'],
  })();

  // Set the updated tariffs
  updatedTariffs.forEach((tariff: any, index: number) => {
    setFields([
      {
        name: tariffKey(index, fullNamePath),
        value: {
          htsNumber: tariff.htsNumber,
        },
      },
    ]);
  });

  return htsValues.htsNumbers[tariffIndex];
};
